import { NumberOfPlayers } from "@biblioteksentralen/cordata";

export const getLocalNumberOfPlayersString = (numberOfPlayers: NumberOfPlayers) =>
  numberOfPlayers.local &&
  (numberOfPlayers.local.minimum === numberOfPlayers.local.maximum
    ? numberOfPlayers.local.minimum
    : `${numberOfPlayers.local.minimum}-${numberOfPlayers.local.maximum}`);
